import React, { Component } from 'react';
import './main.css';
import {Route, Switch, Link} from 'react-router-dom';
import {isMobile} from 'react-device-detect';
import View from '../view/view.js';
import Index from '../index/index.js';
import Projects from '../projects/projects.js';
import Reps from '../reps/reps.js';
import {Helmet} from 'react-helmet'



class Main extends Component {
    constructor(){
        super();
        this.iCount = 0;
        this.images=[];
        this.timer=null
        this.frames=0;
        this.sec=0;
        this.min=0;
        this.hour=0;
        this.stageRef = null
        this.mapKeys = {};
        this.crawlRef = null
        this.state = {
            mobile:false,
            menu:false,
            rep: false,
            index:false,
            vid: false,
            filter:"all",
            secondary:false,
            win:[0,0],
            info: [],
            data:[],
            dataShow:[],
            mapActive:true,
            imgSize: 1600,
            proActive:false,
            infoActive: false,
            mPos:[0,0],
            mScale:2.5,
            cx: 0,
            cy:0,
            date:[0,0,0],
            rec:[0,0,0,0],
            hover:null,
            count:0,
            image:0,
            enable:false,
            pan:false,
            px:0,
            py:0,
            tilt:[0,0,0],
            cTilt:[0,0,0],
            finger:false,
            initF:[0,0],
            currHover:"",
            prompt:false,
            loaded: false,
            approved: false,
            currTitle:"",
            currDes: ""

        }

    };


    componentDidMount(){
        var url = window.location.href
        var curr = url.split('/')[3];
        if((curr==="work")||(curr.startsWith("?"))){
          curr = null
        }
       
        else{
          this.getProjects();
        }
        this.getInfo();
        this.getDate();
        this.resizeWin();
        this.rec();
        this.initView();
        window.addEventListener('resize', this.resizeWin, false)
        if(isMobile){
          document.addEventListener('touchstart', this.touchStart, {passive:false});
          document.addEventListener('touchend', this.touchStop, {passive:false});
          document.addEventListener('touchmove', this.touchMove, {passive:false});
        }
        else{
          document.addEventListener('mousemove', this.trackMouse, {passive:false});
          window.addEventListener('keydown', this.menuCheck, false); 
        }
    }

    handleTilt=(e)=>{
      if ( typeof( DeviceMotionEvent ) !== "undefined" && typeof( DeviceMotionEvent.requestPermission ) === "function" ){
      DeviceOrientationEvent.requestPermission()
        .then(response => {
          if (response == 'granted') {
              this.setState({approved:true},()=>{
                window.addEventListener("deviceorientation", this.initTilt, false);
              })
            
      
            
          }
         
        })
      }
        this.setState({prompt:true}) 
    }

    touchStart=(e)=>{
      
      if(this.state.mapActive){
        if(!this.state.rep && !this.state.index){
          if(this.state.approved){
      window.removeEventListener("deviceorientation", this.tilt, false);
          }
      clearTimeout(this.timer)
      this.setState({finger:true, pan:true, mapActive:false, initF:[e.touches[0].clientX, e.touches[0].clientY]})
      }
    }
    }

    touchStop=(e)=>{
      if(this.state.pan){
      this.setState({finger:false,pan:false, mPos:[0,0], mapActive:true},()=>{
        if(this.state.approved){
        window.addEventListener("deviceorientation", this.initTilt, false);
        }
        this.timer=setTimeout(this.moveMap, 15)
      })
    }
    }

    touchMove=(e)=>{
      if(this.state.pan){
        if(!this.state.rep && !this.state.index){
      e.preventDefault();
      if(this.state.finger){
        var vx =  ((e.touches[0].clientX - this.state.initF[0]))*-1
      var vy =  ((e.touches[0].clientY - this.state.initF[1]))*-1
      var cx= (this.state.cx-vx)
      var cy= (this.state.cy-vy)
      if(cx > 0) cx=0
      if(cy > 0) cy=0
      if(cx < ((this.state.win[0]*(-1*this.state.mScale)+this.state.win[0]))) cx=this.state.win[0]*(-1*this.state.mScale)+this.state.win[0]
      if(cy < ((this.state.win[0]*(-1*this.state.mScale)+(this.state.win[1])))) cy=this.state.win[0]*(-1*this.state.mScale)+(this.state.win[1])
      this.setState({cx: cx, cy:cy,initF:[e.touches[0].clientX, e.touches[0].clientY]})
      }
    }
    }
    }

    initTilt=(e)=>{
        if(!this.state.pan){        
        var x    = (e.alpha);
        var y     = (e.beta);
        var z    = (e.gamma);
        this.setState({pan:true,tilt:[x,y,z]})
      
      }
      else{
        window.removeEventListener('deviceorientation', this.initTilt, false);
        window.addEventListener("deviceorientation", this.tilt, false);
      }
      
    }

    tilt=(e)=>{
      if(!this.state.finger){
      var x = (e.alpha);
      var y = (e.beta);
      var z = (e.gamma);
   
        var vx =  (((z - this.state.tilt[2])/90)*-1)
        var vy =  (((y - this.state.tilt[1])/90)*-1)
        this.setState({mPos:[vx, vy], cTilt:[x,y,z]})
      }
    }

    resizeWin = () => {
      this.setState({win:[window.innerWidth,window.innerHeight]},()=>{
        if((window.innerWidth <= 800)){
          this.setState({mobile:true, mScale:(this.state.secondary && (this.state.filter !=="music")?(2):(5.25))})
  
        }
        else if((window.innerWidth > 800)){
          this.setState({mobile:false, mScale:(this.state.secondary && (this.state.filter !=="music")?(1.2):(2.5))})
        }
      })
      
      
    }

    initIndex=()=>{
      if(!this.state.index){
      this.setState({mapActive:false, index:true, pan:false, finger:false},()=>{
       
          this.menuOff();
          this.repOff();
      })
    }
    else{
      this.setState({mapActive:true, index:false, pan:true, finger:true},()=>{
       
        this.menuOff();
        this.repOff();
        this.moveMap();
    })
    }
    }

    initView=()=>{
      this.setState({index:false, mapActive:true},()=>{
        this.menuOff();
          this.repOff();
          this.moveMap();
      })
    }

    menuCheck=(e)=>{
      this.mapKeys[e.key] = e.type === 'keydown';
     
      if((this.state.menu && e.key==="Escape") ||(this.state.rep && e.key==="Escape") ){
          this.menuOff();
          this.repOff();
  
      }
      if(this.mapKeys['m'] || this.mapKeys['M']){
        this.toggleMenu();
        }
        if(this.mapKeys['r'] || this.mapKeys['R']){
          this.toggleRep();
          }
  }

   
    trackMouse=(e)=>{
      var vx =  ((e.clientX - this.state.win[0]/2)/this.state.win[0]*(this.state.mScale))
      var vy =  ((e.clientY - this.state.win[1]/2)/this.state.win[1]*(this.state.mScale))
      this.setState({mPos:[vx, vy]},()=>{
        if(this.state.hover && this.state.count){
          this.calcImg(e)
        }
      })
      
    }

    initCrawl=(e)=>{
      if(!this.state.hover && !this.state.count){
      var id = e.currentTarget.getAttribute('data-id')
      if(this.state.hover!==parseInt(id)){
      var info = e.currentTarget.getAttribute('data-info')
      var count = parseInt(e.currentTarget.getAttribute('data-item'))
      this.setState({currHover: info, hover: id},()=>{
        if(((count > 1)&&!this.state.menu) || this.state.index ){
          this.crawlRef = document.getElementById(`${this.state.proActive?("proThumb"):"thumb"}-${id}`)
          this.setState({ count:count })
          }
  
      
        })
      }
    }
     
    }
    deCrawl=(e)=>{
      if(this.state.hover){
      this.crawlRef = null;
      this.setState({hover:null, count:null,currHover:null, image:0})
      }
    }

    calcImg=(e)=>{
      if(this.crawlRef){
      var block = this.crawlRef.getBoundingClientRect();
      var curr = Math.ceil(((e.clientX - block.left)/block.width)*(this.state.count)-1);
      if(curr >= parseInt(this.state.count)){
        curr = this.state.count-1
      }
      else if(curr < 0){
        curr = 0;
      }
      if(this.state.image !== curr )
      this.setState({image: curr})
    }
    }


    preventBehavior=(e)=> {
      e.preventDefault(); 
  };

    getInfo = () => {
      fetch(('/api/info'))
      .then(res => res.json())
      .then(data => this.setState({
          info: data.data, currTitle:data.data[0].title, currDes:data.data[0].about},()=>{
            var curr = window.location.href
            var currFilter = curr.split('/')[3];
            if(currFilter){
              this.initFilter(currFilter)
            }
            var currSec = curr.split('/')[4]
            if(currSec){
              this.initPro();
            }
          }));

    }


 

    initPro=(e)=>{
      var cx=0
      var cy=0
      
      if(e){
        cx = e.clientX;
        cy = e.clientY;
      }
      this.initStage(cx, cy)
    

    }

    initIndexPro=()=>{
      this.setState({proActive:true})
    }

    initInfo=()=>{
      if(!this.state.infoActive){
      this.setState({
        infoActive:true
      })
    }
    }


    deInfo=()=>{
      if(this.state.infoActive){
        this.setState({
          infoActive:false
        })
      }
    }

    
    filterKey=(array,sec,term)=>{
      var results = array.filter(function (entry) { return entry[sec] === term; });
      return results
    }

    stopAllVids=()=>{
      var el = document.getElementsByTagName('video')
      if(el.length){
        for (let i = 0; i < el.length; i++) {
              el[i].pause();
        }
      }
    }

    playAllVids=()=>{
      var el = document.getElementsByTagName('video')
      if(el.length){
        for (let i = 0; i < el.length; i++) {
              el[i].play();
        }
      }
    }

    initStage=(cx,cy)=>{
  
      this.stageRef.style.transformOrigin = `${cx/this.state.win[0]*100}vw ${cy/this.state.win[1]*100}vh`
      this.setState({mapActive:false, proActive:true,pan:false, finger:false},()=>{
        this.stopAllVids();
      })
      

    }

    dePro=(e)=>{
      this.setState({proActive:false},()=>{
        if(!this.state.mapActive && !this.state.index){
          this.setState({mapActive:true},()=>{
            this.playAllVids();
            this.moveMap();
  
          })
          }
      })
    }

        
    moveMap =()=>{
      clearTimeout(this.timer)
      if(this.state.mapActive){
      var speed = 12;
      if(this.state.hover){
        speed = 8
      }
      var cx= (this.state.cx-this.state.mPos[0]*speed)
      var cy= (this.state.cy-this.state.mPos[1]*speed)
      if(cx > 0) cx=0
      if(cy > 0) cy=0
      if(cx < ((this.state.win[0]*(-1*this.state.mScale)+this.state.win[0]))) cx=this.state.win[0]*(-1*this.state.mScale)+this.state.win[0]
      if(cy < ((this.state.win[0]*.6*(-1*this.state.mScale)+(this.state.win[1])))) cy=this.state.win[0]*.6*(-1*this.state.mScale)+(this.state.win[1])
      this.setState({cx: cx, cy:cy},()=>{
        this.timer=setTimeout(this.moveMap, 15)
      })
     
     
    }
  }

    runScope=()=>{
      let scope = []
      for (let i = 0; i < 11; i++) {
        var cur = i*10
      scope.push(<div key={`measure-${i}`}className="singleScope"><p className="tFooter">{cur}</p></div>)
      }
      return(scope);
    }

    getDate=()=> {
      var now = new Date();
      var day = now.getDate();
      var month = now.getMonth();
      if(day < 10){
        day = `0${day}`
      }
      if((month+1) < 10){
        month = `0${month+1}`
      }
      else{
        month = month+1
      }
      this.setState({date:[month,day, now.getFullYear()]})
    }

    rec=()=>{
      this.frames=this.frames+1
      if(this.frames >= 24){
        this.frames=0;
        this.sec=this.sec+1
      }
      if(this.sec>=60){
        this.sec=0;
        this.min=this.min+1;
      }
      if(this.min >= 60){
        this.min=0;
        this.hour=this.hour+1;
      }

      this.setState({rec:[this.hour, this.min, this.sec, this.frames]},()=>{
        this.recTime = setTimeout(this.rec,42)
      })
    }

    getImg=(name,size)=>{
      const url = `https://helman.imgix.net/${name}?auto=compress&w=${size}&fit=clip`;
      return(url)
    }

    toggleMenu=()=>{
      if(this.state.rep){
        this.repOff();
      }
      this.setState({menu: !this.state.menu},()=>{
        this.mapKeys = {}
      })
    }
    toggleRep=()=>{
      if(this.state.menu){
        this.menuOff();
      }
      this.setState({rep: !this.state.rep},()=>{
        window.scrollTo(0,0);
        this.mapKeys = {}
      })
    }

    menuOff=()=>{
      this.setState({menu:false})
    }
    repOff=()=>{
      this.setState({rep:false})
    }

    vidPlay=()=>{
      this.setState({vid:true})
    }
    vidPause=()=>{
      this.setState({vid:false})
    }
    

    // loadDone
    loadDone = ()=>{
      this.setState({loaded:true},()=>{
        this.moveMap();
      })
    }
    //Filtering
    filter = (e)=>{
      var curr = e.currentTarget.getAttribute('data-filter')
      this.initFilter(curr)
      
    }

    initFilter=(curr)=>{
      var sec = false
      this.stopAllVids();
      this.setState({loaded:false},()=>{
        if(curr !== this.state.filter){
          if((curr !== "all"))
          {sec = true}
          this.setState({filter: curr, secondary:sec},()=>{
            if(curr==="all"){
              curr = null
              this.changeMeta()
            }
            else if(curr==="commercial"){
              var title = "Commercials Directed by David M. Helman"
              var des = this.state.info[0].commercial
              this.changeMeta(title,des)
            }
            else if(curr==="music"){
              var title = "Music Videos Directed by David M. Helman"
              var des = this.state.info[0].music
              this.changeMeta(title,des)
            }
            else if(curr==="short"){
              var title = "Short Films Directed by David M. Helman"
              var des = this.state.info[0].short
              this.changeMeta(title,des)
            }
            this.getProjects(curr);
          })
        }
        this.menuOff();
      })
    }

    getProjects = (curr) => {

      fetch((`/api/projects${(curr?(`?filter=${curr}`):"")}`))
      .then(res => res.json())
      .then(data => this.setState({
          data: data.data},()=>{
            this.sortProjects();

          }));
    }

    
    sortProjects = () => {

     this.setState({
          dataShow: this.filterKey(this.state.data,"credits",false)},()=>{
            this.resizeWin();
            this.countImgs();
          });
    }

    countImgs=()=>{
      var pro = [...this.state.data]
      pro.forEach((pro,i)=>{
          if(!pro.vidThumb){
              this.iCount++
              if(pro.media.length){
              this.images.push(pro.media[0].name)
              }
          }
      })
      this.preloadImg();
  }

  preloadImg=()=>{
      this.images.forEach((name,i)=>{
          const img = new Image();
          img.src = this.getImg(name,800);
      })
      console.log(this.images)
      this.loadDone();
      
  }

  changeMeta=(title, des)=>{
  
      this.setState({currTitle:(title?(title):(this.state.info[0].title)),
                        currDes:(des?(des):(this.state.info[0].about))})
  
  }

  titleCase=(str)=> {
    return str.toLowerCase().split(' ').map(function(word) {
      return (word.charAt(0).toUpperCase() + word.slice(1));
    }).join(' ');
  }


    render() {
      const { info } = this.state;
      const {proActive} = this.state;
      const {infoActive} = this.state;
      const {win} = this.state;
      const {vid} = this.state;
      const {mScale} = this.state;
      const {cx} = this.state;
      const {cy} = this.state;
      const {date} = this.state;
      const {rec} = this.state;
      const {index} = this.state;
      const {menu} = this.state;
      const {rep} = this.state;
      const {filter} = this.state;
      const { currHover } = this.state;
      const {hover} = this.state;
      const {mPos} = this.state;
      const {tilt} = this.state;
      const {cTilt} = this.state;
      const {pan} = this.state;
      const {initF} = this.state;
      const {finger} = this.state;
      const {mobile} = this.state;
      const {prompt} = this.state;
      const {loaded} = this.state;
    return (
    
      <React.Fragment>
            <Helmet>
                <title>{this.state.currTitle}</title>
                <meta name="description" content={this.state.currDes} />
                <meta name="robots" content="index, follow"/>
            </Helmet>
          {(isMobile && (!prompt))?(
            <div className={`tBlack mobileTest eFill bgWhite ${prompt?('noEvent'):('')} `} style={{minHeight:win[1], minWidth:win[0]}} onClick={this.handleTilt.bind(this)}>
            <div className="centeredContent fullWidth">
              <p className="tCenter tUpper">Tap to Start<br/>drag to explore</p>
            </div>
                  {/* <div className="tFooter centeredContent bgBlack">
                  <p>alpha:{tilt[0]} <br/>{cTilt[0]} </p>
                  <p>beta:{tilt[1]}<br/>{cTilt[1]}</p>
                  <p>gamma:{tilt[2]} <br/> {cTilt[2]} </p>
                  <p>{finger?"fingerStart":"fingerstop"}</p>
                  <p>x:{initF[0]}</p>
                  <p>y:{initF[1]}</p>
                  <p>{`x:${mPos[0]}, y:${mPos[1]}`}</p>
                  <p>{mPos[0]*40}</p>
                  <p>vx:{cx}, vy:{cy}</p>
                  </div> */}
            </div>
          ):('')}
         <div id="repHold" className={`${rep?"active":""} ${vid?('darkmode'):('')}`} style={{width:win[0], height:(rep?('auto'):(0))}}>
              <div className="repBack fullWidth fullHeight bgWhite" onClick={this.toggleRep.bind(this)}></div>
            <Route path='/' render={()=><Reps  getImg={this.getImg} initInfo={this.initInfo} deInfo={this.deInfo} win={this.state.win} info={this.state.info}/>} />
        </div>
        {/* <div id="menu" className={`${menu?"active":""} noEvent`} style={{width: win[0], height: win[1]}}>
            <div className={`menuBack fullWidth fullHeight bgWhite ${menu?"eFill":''}`} onClick={this.toggleMenu.bind(this)}></div>
            <div className="fullStage ptHuge eCenter tBlack relative noEvent">
                <div className="viewSelect fullWidth ptMed pbMed bBot bBlack bBotSm">
                    <div className="textStage eCenter">
                    <p className="tUpper" >FORMAT</p>
                    <Link className={`${menu?(`eFill`):('')}`} onClick={this.initView.bind(this)}  to="/">
                      <h1 className={`${index?"":"active"} tUpper filterBut cPointer ${menu?(`eFill`):('')}`}> Viewfinder</h1>
                    </Link>
                    <Link className={`${menu?(`eFill`):('')}`} onClick={this.initIndex.bind(this)}  to="/">
                      <h1 className={`${index?"active":""} tUpper cPointer filterBut ${menu?(`eFill`):('')}`}> Index</h1>
                    </Link>
                    </div>
                </div>
                <div className="viewSelect ptMed pbMed ">
                <div className="textStage eCenter">
                    <p className="tUpper">Filter</p>
                    <Link className={`${menu?(`eFill`):('')}`} onClick={this.filter.bind(this)}  data-filter="all" to="/">
                     <h1 className={`cPointer tUpper filterBut ${menu?(`eFill`):('')} ${filter==="all"?"active":""}`} data-filter="all">all</h1>
                    </Link>
                    <Link className={`${menu?(`eFill`):('')}`} onClick={this.filter.bind(this)}  data-filter="music" to="/music">
                    <h1 className={`cPointer tUpper filterBut ${menu?(`eFill`):('')} ${filter==="music"?"active":""}`} data-filter="music">music videos</h1></Link>
                    <Link className={`${menu?(`eFill`):('')}`} onClick={this.filter.bind(this)}  data-filter="commercial"to="/commercial">
                    <h1 className={`cPointer tUpper filterBut ${menu?(`eFill`):('')} ${filter==="commercial"?"active":""}`} data-filter="commercial">commercials</h1></Link>
                    <Link className={`${menu?(`eFill`):('')}`} onClick={this.filter.bind(this)}  data-filter="short"to="/short">
                    <h1 className={`cPointer tUpper filterBut ${menu?(`eFill`):('')} ${filter==="short"?"active":""}`} data-filter="short">short film</h1></Link>
                </div>
                </div>
            </div>
        </div> */}
      {info.length ?(
        <React.Fragment>
          {!isMobile?(
                      <div className={`${vid?('darkmode'):('')} footerInfo fullWidth ${((currHover && !index && !proActive)?"active":"")}`}> <p className="tCenter tBlack tCaption tUpper">{this.state.currHover}</p></div>
          ):('')}
        
        <div id="nav" style={{width:win[0], height:win[1]}} className={`tblack ${vid?'playing darkmode':''}`}>
          <div id="leftNav" className="leftNav navItem" style={{height: win[1]}}>
              <div id="infoHolderL" className={`flex navItemPre plMed prMed flexAEnd pbMed ${(proActive)?"hide":""} ${((proActive && menu) || (proActive && rep))?"hideOff":""}`} style={{width:win[1]}}>
               
                  <Link to="/"><div><h1 className=" tUpper navBut">David</h1></div> </Link>
                  <Link to="/"><div><h1 className=" tUpper navBut">M</h1></div> </Link>
                  <Link to="/"><div><h1 className=" tUpper navBut">Helman</h1></div> </Link>
             
                
              
              </div>
          </div>

          <div id="rightNav" className="rightNav navItem" style={{height: win[1]}}>
              <div id="infoHolderR" className="flex plMed prMed navItemPre flexAEnd pbMed" style={{width:win[1]}}>
                {loaded?(
                  <React.Fragment>
                    <Link to="/"><div onClick={this.initIndex.bind(this)}><h2 className=" tUpper navBut cPointer relative menuBut"><span className="butSuggest">A</span>rchive<span className={`menuPlus ${index?"closeMode":""}`}>+</span></h2></div></Link>
                    <div onClick={this.toggleRep.bind(this)}><h2 className=" tUpper navBut cPointer relative menuBut"><span className='butSuggest'>I</span>nfo<span className={`menuPlus ${rep?"closeMode":""}`}>+</span></h2></div>
                  </React.Fragment>
                ):(
                  <div onClick={this.toggleMenu.bind(this)}><h2 className="blink  tUpper navBut cPointer relative menuBut">Loading</h2></div>

                )}
                  
              </div>
          </div>
          <div id="scopeL" className={`${vid?('darkmode'):('')}`} style={{width:win[1]}}>
                <div className="scopeHold  plSm prSm flex tBlack" style={{minWidth:win[1], width:((proActive || index || rep)?((document.height !== undefined) ? document.height : document.body.offsetHeight):(win[0]*.6*mScale)),transform:((proActive || index || rep)?(`translate3d(${-1*window.pageYOffset}px,0,0)`):(`translate3d(${cy}px,0,0)`))}}>
                  {this.runScope()}
                </div>
              </div>

              <div id="scopeB" className={`${vid?('darkmode'):('')}`} style={{width:win[0]}}>
                <div className="scopeHold plSm prSm flex tBlack" style={{width:((proActive|| index || rep)?(win[0]):(win[0]*mScale)),transform:((proActive || index || rep)?(`translate3d(0,0,0)`):(`translate3d(${cx}px,0,0)`))}}>
                 
                  {this.runScope()}
                </div>
              </div>
              <div id="timeSlide" className={`${vid?('darkmode'):('')}`}>
                  <div className="date "><p className={`tUpper tFooter tBlack`}>
                    <span className='prXs day tBlack'>{date[0]}</span><span className='prXs day'>.</span><span className='prXs day'>{date[1]}</span><span className='prXs day'>.</span><span className='prLrg day tBlack'>{date[2]}</span>
                    <span className='prXs tBlack'>{rec[0]<10?`0${rec[0]}`:`${rec[0]}`}</span><span className='prXs'>:</span><span className='prXs'>{rec[1]<10?`0${rec[1]}`:`${rec[1]}`}</span><span className='prXs tBlack'>:</span><span className='prXs'>{rec[2]<10?`0${rec[2]}`:`${rec[2]}`}</span><span className='prXs'>:</span><span>{rec[3]<10?`0${rec[3]}`:`${rec[3]}`}</span>
            
                  </p></div>
              </div>

        </div>
        <div className={`appHolder ${proActive?('active'):('')} ${rep?('repActive'):('')} ${index?('indexActive'):('')} ${vid?('darkmode'):('')}`}>
          <div id="appContain" className={`${hover?"hoverMode":""} bgWhite relative ${infoActive?('infoActive'):('')}`} style={{height: (index?("auto"):("100vh")), width: "100vw"}} ref={element => this.stageRef = element}>
              
            {index?(
                  <Route path='/' render={()=><Index titleCase={this.titleCase}  isMobile={isMobile} data={this.state.data} rep={rep} mobile={mobile} count={this.state.count} hover={this.state.hover} image={this.state.image} deCrawl={this.deCrawl} initCrawl={this.initCrawl} getImg={this.getImg}  initPro={this.initIndexPro}  proActive={this.state.proActive} info={this.state.info[0]} win={this.state.win}/>} />
            ):(
                  <Route path='/' render={()=><View  titleCase={this.titleCase}  isMobile={isMobile} loaded={this.state.loaded} filter={this.state.filter} secondary={this.state.secondary} data={this.state.dataShow} loadDone={this.loadDone} mobile={mobile}  count={this.state.count} hover={this.state.hover} image={this.state.image} deCrawl={this.deCrawl} initCrawl={this.initCrawl} getImg={this.getImg} moveMap={this.moveMap} cx={this.state.cx} cy={this.state.cy} initPro={this.initPro} mScale={this.state.mScale} mPos={this.state.mPos} mapActive={this.state.mapActive} proActive={this.state.proActive} info={this.state.info[0]} win={this.state.win}/>} />
            )}


        
          </div>
        </div>
  
        
          <Route path='/work' render={()=><Projects titleCase={this.titleCase} changeMeta={this.changeMeta} mobile={mobile} menu={this.state.menu} rep={this.state.rep} count={this.state.count} hover={this.state.hover} image={this.state.image} deCrawl={this.deCrawl} initCrawl={this.initCrawl} getImg={this.getImg} vid={vid} vidPlay={this.vidPlay} vidPause={this.vidPause} proActive={this.state.proActive} dePro={this.dePro} initPro={this.initPro} win={this.state.win}/>} />

        
        </React.Fragment>
        

      ):("")}
      
       </React.Fragment>
    
    );
  }
}

export default Main;



// WEBPACK FOOTER //
// ./src/components/main/main.js